export default __webpack_public_path__ + "3945c58fbde7509c0b6ad00f65ecab0d.png";